import React from "react";
import bulb from '../Images/Bulb.png'
import eyes from '../Images/Eyes.png'
import stock from '../Images/Stock.png'
import heart from '../Images/Heart.png'
import { motion } from "framer-motion";



const Secone = () => {

    const background = {
        background: '#EEEE',
        paddingTop: '40px',
        paddingBottom: '40px',
    }

    const glideUp = {
        initial: { opacity: 0, y: 60 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.7 },
        viewport: { once: true }
    };

    return(
        <>
        <div style={background}>
         <div className="container" style={background}>
            <div className="row g-4" style={{marginTop: '80px'}}>
                <div style={{display: 'flex', justifyContent: 'space-between'}}>
                    <div>
                        <h6 style={{color: '#F29235', fontWeight: '700', letterSpacing: '5px'}}>FOUNDATION</h6>
                        <h2 style={{color: '#353995', fontWeight: '700'}}>OUR Core Values</h2>
                    </div>
                    <div>
                        <p>The principle that guide every line <br /> of code and every client interaction</p>
                    </div>
                </div>
                <div className="col-md-3 mt-5">
                    <motion.div {...glideUp}>
                        <div className="cards p-4">
                        <img className="img-fluid align-items-center" style={{width: '60px'}} src={bulb} alt="" />
                        <h4 className="mt-4" style={{color: '#353995', fontWeight: '700'}}>Innovation</h4>
                        <p className="mt-4">
                            Pushing the boundaries of what’s possible in B2B Landscape through creative engineering
                        </p>                        
                        </div>
                    </motion.div>
                    </div>

                    <div className="col-md-3 mt-5">
                    <motion.div {...glideUp}>
                        <div className="cards p-4">
                        <img className="img-fluid" style={{width: '60px'}} src={eyes} alt="" />
                        <h4 className="mt-4" style={{color: '#353995', fontWeight: '700'}}>Transparency</h4>
                        <p className="mt-4">
                            Open communication to every partnership. No hidden agendas, just honest collaboration.
                        </p>                        
                        </div>
                    </motion.div>
                    </div>

                    <div className="col-md-3 mt-5">
                    <motion.div {...glideUp}>
                        <div className="cards p-4">
                        <img className="img-fluid" style={{width: '60px'}} src={stock} alt="" />
                        <h4 className="mt-4" style={{color: '#353995', fontWeight: '700'}}>Client Success</h4>
                        <p className="mt-4">
                            Your growth is our primary metric. We win only when your business scales and thrives.
                        </p>                        
                        </div>
                    </motion.div>
                    </div>

                    <div className="col-md-3 mt-5">
                    <motion.div {...glideUp}>
                        <div className="cards p-4">
                        <img className="img-fluid" style={{width: '60px'}} src={heart} alt="" />
                        <h4 className="mt-4" style={{color: '#353995', fontWeight: '700'}}>Empathy</h4>
                        <p className="mt-4">
                            Understanding the real humans behind the screens to build tools that actually improve lives.
                        </p>
                        </div>
                    </motion.div>
                    </div>
            </div>
          </div>
        </div>
  
        </>
    )
}

export default Secone;